import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import createPersistedState from 'vuex-persistedstate'
import moment from 'moment'

import {
  Firebase,
  db,
  profileStorageRef,
  assetsRef,
  jsonFileStorageRef
  // storiesRef,
  // usersRef
} from '../firebaseDB'
import { log } from '@tensorflow/tfjs'
import { unset } from 'lodash'
import Swal from 'sweetalert'
import assets from './assets'
import { relativeTimeRounding } from 'moment'

Vue.use(Vuex)

let initialState = () => ({
  user: null,
  profile: {
    bio: '',
    role: '',
    name: '',
    birthday: '',
    gender: '',
    hometown: '',
    location: '',
    picture_url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Default_profile_picture_%28male%29_on_Facebook.jpg/900px-Default_profile_picture_%28male%29_on_Facebook.jpg'
  },
  newStory: {
    id: null,
    title: '',
    subtitle: '',
    organization: '',
    flex: 4,
    author: '',
    team: '',
    topics: [''],
    imageName: '',
    imageUrl: '',
    imageFile: '',
    experience: {},
    isStarred: false,
    date: null,
    diagramData: {},
    nodeContentArray: ['']
  },
  timeLineCursor: 0,
  error: null,
  loading: false,
  userEmail: '',
  selectedStory: null,
  profileImageUrl: null,
  stories: [],
  teams: [],
  members: [],
  check_Password: true,
  updatedPassword: false,
  changePassword: false,
  ChangePasswordError: null,
  newStoryAddedId: null,
  sounds: null,
  effects: null,
  mediaImages: null,
  fbxModels: null,
  assetAnimations: null,
  images: null,
  propModels: null,
  characters: [],
  videos: {},
  inspector: {
    main: {
      startTime: 0,
      endTime: 0,
      name: '',
      image: '',
      model: {}
    },
    animation: {},
    light: {},
    sound: {},
    movement: {},
    effects: {},
    textToSpeech: {}
  },
  objectId: '',
  jsonInspector: {},
  selectedLogic: {},
  nodeElementIndex: 0,
  isNodeElementExist: false,
  selectedStoryId: {},
  filters: [],
  fileState : {},
  unityInstanceReady : false,
  checkedfilters: [],
  modelOpened: false,
  sideBarState: false,
  onMobileTablet: false,
  currentPageRoute: null,
  sceneElementCurrentPopup: -1
})

export const store = new Vuex.Store({
  state: initialState,
  plugins: [createPersistedState],
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setUserEmail (state, payload) {
      state.userEmail = payload
    },
    setStories (state, payload) {
      state.stories = payload
    },
    setTeams (state, payload) {
      state.teams = payload
    },
    setMembers (state, payload) {
      state.members = payload
    },
    setSelectedStory (state, payload) {
      state.selectedStory = payload
    },
    addNewNode (state, payload) {
      state.stories.filter(story => story.title === payload.title)[0].diagramData.nodeDataArray = payload.nodeData
    },
    fbSetProfile (state, payload) {
      state.profile.name = payload.name
      state.profile.birthday = payload.birthday
      state.profile.gender = payload.gender
      state.profile.hometown = payload.hometown.name
      state.profile.location = payload.location.name
      state.profile.picture_url = payload.picture.data.url
    },
    setCurrentNode (state, payload) {
      state.currentNode = payload.currentNode
    },
    setCheckPassword (state, payload) {
      state.check_Password = payload
    },
    setUpdatedPassword (state, payload) {
      state.updatedPassword = payload
    },
    setChangePassword (state, payload) {
      state.changePassword = payload
    },
    setChangePasswordError (state, payload) {
      state.ChangePasswordError = payload
    },
    setNewAddedStoryId (state, payload) {
      state.newStoryAddedId = payload
    },
    setSounds (state, payload) {
      state.sounds = payload
      for (const sound in state.sounds) {
        state.sounds[sound].showStopButton = false
      }
    },
    setVideos (state, payload) {
      for (const video in payload) {
        payload[video].showStopButton = false
      }
      state.videos = payload
    },
    setEffects (state, payload) {
      state.effects = payload
    },
    setMediaImages (state, payload) {
      state.mediaImages = payload
    },
    setFBXModels (state, payload) {
      state.fbxModels = payload
    },
    setAssetAnimations (state, payload) {
      state.assetAnimations = payload
    },
    setPropModels (state, payload) {
      state.propModels = payload
    },
    setSelectedLogic (state, payload) {
      state.selectedLogic = payload
    },
    setNodeElementIndex (state, payload) {
      state.nodeElementIndex = payload
    },
    setStoryInfo (state, payload) {
      state.nodeElementIndex = payload
    },
    setInspectorData (state, payload) {
      let successCallback = payload['successCallback'] ? payload['successCallback'] : ''
      let errorCallback = payload['errorCallback'] ? payload['errorCallback'] : ''
      delete payload['successCallback']
      delete payload['errorCallback']
      let updates = {}
      let isNodeElementExist = false
      let story = db.ref('stories').child(localStorage.getItem('storyId'))
      let selectedLogic = JSON.parse(localStorage.getItem('selectedLogic'))
      story.once('value', snapshot => {
        if (snapshot.val()) {
          let json = snapshot.val().json
          let selectedNodePosition = selectedLogic.nodePosition
          if (json.mainStory.nodes[selectedNodePosition].hasOwnProperty('nodeElements')) {
            for (const snapshotkey in json.mainStory.nodes[selectedNodePosition].nodeElements) {
              if (json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].hasOwnProperty('character') && payload.elementType === json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].elementType) {
                if (payload.character.objectId === json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.objectId) {
                  isNodeElementExist = true
                  json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey] = payload
                  break
                }
              } else if (json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].hasOwnProperty('object3D') && payload.elementType === json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].elementType) {
                if (payload.object3D.objectId === json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].object3D.objectId) {
                  isNodeElementExist = true
                  json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey] = payload
                  break
                }
              } else {
                if (payload.elementType === json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].elementType && payload.id === json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].id) {
                  isNodeElementExist = true
                  json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey] = payload
                }
              }
            }
          }
          if (!isNodeElementExist) {
            if (!json.mainStory.nodes[selectedNodePosition].hasOwnProperty('nodeElements')) {
              json.mainStory.nodes[selectedNodePosition].nodeElements = []
            }
            json.mainStory.nodes[selectedNodePosition].nodeElements.push(payload)
          }
          updates[localStorage.getItem('storyId') + `/json`] = json
          db.ref('stories').update(updates).then(snapshot => {
            successCallback && successCallback()
          }).catch(e => {
            console.log(e)
            errorCallback && errorCallback()
          })
        }
      })
    },
    setMainInspectorData (state, payload) {
      state.inspector.main.startTime = payload.main.startTime
      state.inspector.main.endTime = payload.main.endTime
      state.inspector.main.name = payload.main.name
      state.inspector.main.image = payload.main.image
      state.inspector.main.model = payload.main.model
      state.inspector.textToSpeech = payload.textToSpeech
      state.inspector.animation = payload.animation
    },
    setCharacters (state, payload) {
      state.characters = payload
    },
    setTimelineCursor (state, payload) {
      state.timeLineCursor = payload
    },
    setSelectedStoryId (state, payload) {
      state.selectedStoryId = payload
    },
    setAnimations (state, payload) {
      state.inspector.animation = payload
    },
    setOnMobileTablet (state, payload) {
      state.onMobileTablet = payload
    },
    setCurrentPageRoute (state, payload) {
      state.currentPageRoute = payload
    }
  },
  actions: {
    userSignUp ({ commit }, payload) {
      commit('setUserEmail', payload.email)
      commit('setLoading', 'init')
      const usersRef = db.ref().child('users')

      // create account
      Firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(firebaseUser => {
          const user = Firebase.auth().currentUser
          user.sendEmailVerification().then(function () {
            // Store image & get the link to store into DB
            profileStorageRef
              .child(`${payload.profileImage.lastModified}`)
              .put(payload.profileImage)
              .then((snapshot) => snapshot.ref.getDownloadURL())
              .catch(function (error) {
                console.log(`Error - ${error.message}`)
              })
              .then((url) => {
                payload.profileImage = url
                usersRef.update({
                  [Firebase.auth().currentUser.uid]: {
                    firstName: String(payload.firstName),
                    lastName: String(payload.lastName),
                    email: String([payload.email]),
                    profession: String(payload.profession),
                    organizationName: String(payload.organizationName),
                    organizationType: String(payload.organizationType),
                    profileImage: payload.profileImage,
                    userId: Firebase.auth().currentUser.uid,
                    role:'creator',
                    createdAt:moment().format('YYYY-MM-DD'),
                    status:true
                  }
                })
                commit('setLoading', 'true')
              })
            // Store image & get the link to store into DB
          }, function (error) {
            commit('setError', error)
            commit('setLoading', 'false')
          })
        })
        .catch(error => {
          commit('setError', error.message)
          commit('setLoading', 'false')
        })
    },
    addUser ({ commit , dispatch }, payload) {
      let admin = Firebase.auth().currentUser
      commit('setUserEmail', payload.email)
      commit('setLoading', 'init')
      const usersRef = db.ref().child('users')
      // create account
      Firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(firebaseUser => {
          const user = Firebase.auth().currentUser
          user.sendEmailVerification().then(function () {
                usersRef.update({
                  [Firebase.auth().currentUser.uid]: {
                    email: String([payload.email]),
                    role:'creator',
                    createdAt:moment().format('YYYY-MM-DD'),
                    status:true
                  }
                })
                commit('setLoading', 'true')
           Firebase.auth().updateCurrentUser(admin)
           store.state.user = {
            ...store.state.user,
            id: admin.uid
          }
          }, function (error) {
            commit('setError', error)
            commit('setLoading', 'false')
          })
        })
        .catch(error => {
          commit('setError', error.message)
          commit('setLoading', 'false')
        })
    },
    userSignIn ({ commit, dispatch }, payload) {
      commit('setLoading', true)

      // sign in with credentials
      Firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(firebaseUser => {
          // Temporarily stopping verification
          /* if (firebaseUser.user.emailVerified) { */
          commit('setUser', { email: firebaseUser.user.email })
          commit('setLoading', false)
          commit('setError', null)

          store.state.user = {
            ...store.state.user,
            id: firebaseUser.user.uid
          }

          // dispatch('pullStories')
          dispatch('pullProfile')

          // go to home
          router.push('/home')
          /* } else {
             commit('setError', 'Please verify your email first')
             commit('setLoading', false)
           } */
        })
        .catch(error => {
          commit('setError', error.message)
          commit('setLoading', false)
        })
    },

    userGoogleSignIn ({ commit, dispatch }, payload) {
      commit('setLoading', true)
              // sign in with google
      let provider = new Firebase.auth.GoogleAuthProvider()
      Firebase.auth()
      .signInWithPopup(provider)
      .then(firebaseUser => {
        const {additionalUserInfo: {isNewUser}} = firebaseUser
        const user = Firebase.auth().currentUser
        if (user.email.substring(user.email.indexOf('@')) !== '@amirbaradaran.com') {
          commit('setError', 'Please sign in with your company account')
        }else{
        if(isNewUser){
          commit('setUserEmail', user.email)
          commit('setLoading', 'init')
         const usersRef = db.ref().child('users')
          user.sendEmailVerification().then(function () {
                usersRef.update({
                  [user.uid]: {
                    firstName: String(user.displayName),
                    email: String([user.email]),
                    userId: user.uid,
                    role:'creator',
                    createdAt:moment().format('YYYY-MM-DD'),
                    status:true
                  }
                })
          commit('setUser', { email: user.email })
          commit('setLoading', false)
          commit('setError', null)
          store.state.user = {
            ...store.state.user,
            id: user.uid
          }
          // dispatch('pullStories')
          dispatch('pullProfile')
          // go to home
              router.push('/home')
            }, function (error) {
              commit('setError', error)
              commit('setLoading', 'false')
            })
          } else {
            commit('setUser', { email: firebaseUser.user.email })
            commit('setLoading', false)
            commit('setError', null)
            store.state.user = {
              ...store.state.user,
              id: firebaseUser.user.uid
            }
            // dispatch('pullStories')
            dispatch('pullProfile')
          // go to home
            router.push('/home')
          }
        }
      })
        .catch(error => {
          commit('setError', error.message)
          commit('setLoading', false)
        })
    },
    autoSignIn ({ commit, dispatch }, payload) {
      commit('setUser', {
        email: payload.email
      })
      // add email hash (id) to user object
      store.state.user = {
        ...store.state.user,
        id: Firebase.auth().currentUser.uid
      }
      // dispatch('pullStories')
      dispatch('pullProfile')
    },
    userSignOut ({ commit }) {
      Firebase.auth().signOut()
      commit('setUser', null)
      store.replaceState(initialState())
      router.push('/')
    },
    resetPassword ({ commit }, payload) {
      commit('setLoading', true)
      Firebase.auth().sendPasswordResetEmail(payload.email)
        .then(() => {
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setError', error.message)
          commit('setLoading', false)
        })
    },
    changePassword ({ commit }, payload) {
      commit('setChangePassword', true)
      let user = Firebase.auth().currentUser
      let credential = Firebase.auth.EmailAuthProvider.credential(
        Firebase.auth().currentUser.email,
        payload.password
      )
      // Prompt the user to re-provide their sign-in credentials
      user.reauthenticateWithCredential(credential).then(function () {
        // cur_password matched
        commit('setCheckPassword', true)
        user.updatePassword(payload.newPassword).then(function () {
          // successfully update the password
          commit('setUpdatedPassword', true)
          setTimeout(() => commit('setUpdatedPassword', false), 1000)
        }).catch(function (error) {
          // failed to update the password
          commit('setUpdatedPassword', false)
          commit('setCheckPassword', false)
          commit('error', error.message)
        })
        commit('setChangePassword', false)
      }).catch(function (error) {
        commit('error', error.message)
        if (error.code === 'auth/wrong-password') {
          // cur_password unmatched
          commit('setCheckPassword', false)
          commit('setUpdatedPassword', false)
          setTimeout(() => {
            commit('setCheckPassword', true)
          }, 1000)
        }
        commit('setChangePassword', false)
      })
    },
    addNode ({ commit, dispatch }, payload) {
      commit('addNewNode', payload)
      // dispatch('pullStories')
    },
    SaveToDB ({ dispatch }, payload) {
      // This is wraped interface to save sotries info to firebase
      // Synchronize cached data with firebase after every change
      // @payload: {refPath: , newData: }
      console.log(payload)
      db.ref(payload.refPath).set(payload.newData)
      // dispatch('pullStories')
    },
    pullStories ({ commit }) {
      // get stories from db
      let usRef = db.ref().child('users/' + store.state.user.id + '/stories')
      usRef.once('value').then(snapshot => {
        let storyKeys = []
        if (snapshot.val()) {
          storyKeys = Object.keys(snapshot.val())
        } else {
          //  store.state.stories = []
        }
        let stories = []
        for (let i = 0; i < storyKeys.length; i++) {
          let tRef = db.ref().child('stories/' + storyKeys[i])
          tRef.once('value').then(snapshot => {
            let cur = snapshot.val()
            try {
              cur['key'] = snapshot.key
              stories.push(cur)
            } catch (err) {
            }
          })
        }
        // commit('setStories', stories)
      })
    },
    pullTeams ({ commit }) {
      // get stories from db
      let usRef = db.ref().child('teams')
      usRef.once('value').then(snapshot => {
        let teams = []
        let cur = snapshot.val()
        try {
          cur['key'] = snapshot.key
          teams.push(cur)
        } catch (err) {
        }
        commit('setTeams', teams)
      })
    },
    pullMembers ({ commit }) {
      // get stories from db
      let usRef = db.ref().child('members')
      usRef.once('value').then(snapshot => {
        let members = []
        let cur = snapshot.val()
        try {
          cur['key'] = snapshot.key
          members.push(cur)
        } catch (err) {
        }
        commit('setMembers', members)
      })
    },
    async listUserStories ({ commit, state }) {
      console.log(state.user.id, 'user_id')
      await db
        .ref()
        .child('stories')
        .orderByChild('user_id')
        // .equalTo(state.user.id)
        .on('value', function (snapShot) {
          const data = snapShot.val()
          let list = []
          for (const snapShotKey in data) {
            if (state.user.id == data[snapShotKey]['user_id'] ||
            (data[snapShotKey]['sharedWith'] && data[snapShotKey]['sharedWith'].includes(state.user.id))) {
              data[snapShotKey]['id'] = snapShotKey
              list.push(data[snapShotKey])
            }
          }
          commit('setStories', list)
        })
    },
    // Todo
    pullProfile () {
      let proRef = db.ref().child('users/' + store.state.user.id + '/profile')
      proRef.on('value', (snapshot) => {
        if (snapshot.val()) {
          // console.log(snapshot.val())
          store.state.profile = snapshot.val()
        }
        // } else { console.log('no profile') }
      })
    },
    // Todo
    pushProfile () {
      let proRef = db.ref().child('users/' + store.state.user.id + '/profile')
      proRef.set(store.state.profile)
    },
    // Todo
    fbLogin ({ commit }) {
      // eslint-disable-next-line
      FB.logout((response) => {
        // user is now logged out
      })
      // eslint-disable-next-line
      FB.login((response) => {
        if (response.authResponse) {
          console.log('Welcome!  Fetching your information.... ')
          // eslint-disable-next-line
          FB.api('/me',
            { fields: 'friends,name,likes,birthday,hometown,gender,location,picture' },
            (response) => {
              // set store values
              commit('fbSetProfile', response)
            })
          // eslint-disable-next-line
          FB.logout((response) => {
            // user is now logged out
          })
        } else {
          console.log('User cancelled login or did not fully authorize.')
        }
      }, {
        scope: 'user_likes,user_birthday,user_hometown,user_age_range,user_friends,user_gender,user_location',
        return_scopes: 'true'
      })
    },
    // Todo
    fbAuth ({
      commit
    }) {
      let provider = new Firebase.auth.FacebookAuthProvider()
      provider.addScope('user_birthday')
      provider.addScope('user_hometown')
      provider.addScope('user_age_range')
      provider.addScope('user_friends')
      provider.addScope('user_gender')
      provider.addScope('user_location')

      Firebase.auth().signInWithPopup(provider).then((result) => {
        // This gives you a Facebook Access Token. You can use it to access the Facebook API.
        // let token = result.credential.accessToken
        // The signed-in user info.
        // let user = result.user
        // ...
      }).catch((error) => {
        // Handle Errors here.
        let errorCode = error.code
        let errorMessage = error.message
        // The email of the user's account used.
        let email = error.email
        // The firebase.auth.AuthCredential type that was used.
        let credential = error.credential
        // ...
        console.log(errorCode)
        console.log(errorMessage)
        console.log(email)
        console.log(credential)
      })
    },
    getUserDevice ({ commit }) {
      var userAgent = navigator.userAgent.toLowerCase(),
        width = screen.availWidth,
        height = screen.availHeight,
        userIsOnMobileDevice = checkIfUserIsOnMobileDevice(userAgent)
      if (userIsOnMobileDevice) {
        console.log("You're on mobile!")
      } else {
        console.log("You're on desktop!")
      }
      function checkIfUserIsOnMobileDevice ($userAgent) {
        if ($userAgent.includes('mobi') || $userAgent.includes('tablet')) {
          commit('setOnMobileTablet', true)
        }
        if ($userAgent.includes('android')) {
          if (height > width && width < 800) {
          // Screen is higher than it's wide, so we have portrait mode
            commit('setOnMobileTablet', true)
          }
          if (width > height && height < 800) {
          // Screen is wider than it's high, so we have landscape mode
            commit('setOnMobileTablet', true)
          }
        }
        commit('setOnMobileTablet', false)
      }
    },
    selectedStory ({ commit }, payload) {
      commit('setSelectedStory', payload)
    },
    setNewAddedStoryId ({ commit }, payload) {
      commit('setNewAddedStoryId', payload)
    },
    listSounds ({ commit }) {
      assetsRef.child('asset_data/sound').on('value', snapshot => {
        commit('setSounds', snapshot.val())
      })
    },
    listVideos ({ commit }) {
      assetsRef.child('asset_data/video').on('value', snapshot => {
        commit('setVideos', snapshot.val())
      })
    },
    listEffects ({ commit }) {
      assetsRef.child('asset_data/effect').on('value', snapshot => {
        commit('setEffects', snapshot.val())
        // let effects = {}
        // for (const index in snapshot.val()) {
        //   if (
        //     snapshot.val()[index].asset_bundle &&
        //     snapshot.val()[index].asset_bundle.Android &&
        //     snapshot.val()[index].asset_bundle.Android.fileURL &&
        //     snapshot.val()[index].asset_bundle.iOS &&
        //     snapshot.val()[index].asset_bundle.iOS.fileURL &&
        //     snapshot.val()[index].asset_bundle.WebGL &&
        //     snapshot.val()[index].asset_bundle.WebGL.fileURL
        //   ) {
        //     effects[index] = snapshot.val()[index]
        //   }
        // }
        // commit('setEffects', effects)
      })
    },
    listMediaImages ({commit}) {
      assetsRef.child('asset_data/overlay').on('value', snapshot => {
        let images = {}
        for (const index in snapshot.val()) {
          images[index] = snapshot.val()[index]
        }
        commit('setMediaImages', images)
      })
    },
    listFBXModels ({ commit }) {
      assetsRef.child('asset_data/character_model').on('value', snapshot => {
        let models = {}
        for (const index in snapshot.val()) {
          if (
            snapshot.val()[index].asset_bundle &&
            snapshot.val()[index].asset_bundle.Android &&
            snapshot.val()[index].asset_bundle.Android.fileURL &&
            snapshot.val()[index].asset_bundle.iOS &&
            snapshot.val()[index].asset_bundle.iOS.fileURL &&
            snapshot.val()[index].asset_bundle.WebGL &&
            snapshot.val()[index].asset_bundle.WebGL.fileURL
          ) {
            models[index] = snapshot.val()[index]
          }
        }
        commit('setFBXModels', models)
      })
    },
    listAssetAnimations ({ commit }) {
      assetsRef.child('asset_data/animation').on('value', snapshot => {
        // let animations = {}
        // for (const index in snapshot.val()) {
        //   if (
        //     snapshot.val()[index].asset_bundle &&
        //     snapshot.val()[index].asset_bundle.Android &&
        //     snapshot.val()[index].asset_bundle.Android.fileURL &&
        //     snapshot.val()[index].asset_bundle.iOS &&
        //     snapshot.val()[index].asset_bundle.iOS.fileURL &&
        //     snapshot.val()[index].asset_bundle.WebGL &&
        //     snapshot.val()[index].asset_bundle.WebGL.fileURL
        //   ) {
        //     animations[index] = snapshot.val()[index]
        //   }
        // }
        commit('setAssetAnimations', snapshot.val())
      })
    },
    listPropModels ({ commit }) {
      assetsRef.child('asset_data/prop').on('value', snapshot => {
        let models = {}
        for (const index in snapshot.val()) {
          if (
            snapshot.val()[index].hasOwnProperty('asset_bundle') &&
            snapshot.val()[index].asset_bundle.hasOwnProperty('Android') &&
            snapshot.val()[index].asset_bundle.Android.hasOwnProperty('fileURL') &&
            snapshot.val()[index].asset_bundle.hasOwnProperty('iOS') &&
            snapshot.val()[index].asset_bundle.iOS.hasOwnProperty('fileURL') &&
            snapshot.val()[index].asset_bundle.hasOwnProperty('WebGL') &&
            snapshot.val()[index].asset_bundle.WebGL.hasOwnProperty('fileURL')
          ) {
             models[index] = snapshot.val()[index]
          }
        }
        commit('setPropModels', models)
      })
    },
    // listVideos ({ commit }) {
    //   assetsRef.child('asset_data/video').on('value', snapshot => {
    //     commit('setVideos', snapshot.val())
    //   })
    // },
    saveInspector ({ commit }, inputData) {
      commit('setInspectorData', inputData)
    },
    saveSelectedLogic ({ commit }, inputData) {
      commit('setSelectedLogic', inputData)
    },
    saveNodeElementIndex ({ commit }, inputData) {
      commit('setNodeElementIndex', inputData)
    },
    uploadJSON ({ state }, inputData) {
      let story = db.ref('stories').child(localStorage.getItem('storyId'))
      story.once('value', snapshot => {
        if (snapshot.val()) {
          let json = snapshot.val().json
          if (json.hasOwnProperty('mainStory') && json.mainStory.nodes.length) {
            for (const jsonElements in json.mainStory.nodes) {
              if (json.mainStory.nodes[jsonElements].hasOwnProperty('nodeElements') && json.mainStory.nodes[jsonElements].nodeElements.length >= 1) {
                let nodeElements = json.mainStory.nodes[jsonElements].nodeElements
                for (const nodeElement in nodeElements) {
                  for (const elements in nodeElements[nodeElement]) {
                    if (
                      nodeElements[nodeElement].elementType === 'Character' &&
                      typeof nodeElements[nodeElement][elements] === 'object' &&
                      !nodeElements[nodeElement][elements].hasOwnProperty('characterElements')
                    ) {
                       nodeElements[nodeElement][elements].characterElements = []
                     }

                    if (
                      nodeElements[nodeElement].elementType === 'object2D' &&
                      typeof nodeElements[nodeElement][elements] === 'object' &&
                      !nodeElements[nodeElement][elements].hasOwnProperty('object2DElements')
                    ) {
                       nodeElements[nodeElement][elements].object2DElements = []
                     }
                  }
                }
              }
            }
          }
          let text = JSON.stringify(json, null, '  ')
          console.log(text)
          let timestamp = Math.floor(Date.now() / 1000) + '.json'
          console.log(timestamp)
          let message = 'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
          jsonFileStorageRef.child(localStorage.getItem('storyId') + '/' + timestamp)
            .putString(message, 'data_url')
            .then((snap) => {
              db.ref('stories').child(localStorage.getItem('storyId')).update({ latest_export: timestamp })
              inputData.successCallback('JSON uploaded successfully')
            }).catch(e => {
              console.log(e)
              inputData.errorCallback('Uploading JSON failed')
            })
        }
      })
    },
    updateTimeLine ({ commit }, payload) {
      commit('setMainInspectorData', payload)
    },
    updateTimeLineCursor ({ commit }, payload) {
      commit('setTimelineCursor', payload)
    },
    updateCharacters ({ commit }, payload) {
      commit('setCharacters', payload)
    },
    updateVideos ({ commit }, payload) {
      commit('setVideos', payload)
    },
    updateStoryID ({ commit }, payload) {
      commit('setSelectedStoryId', payload)
    },
    changeObjectId ({ commit }, payload) {
      // commit('setObjectId', payload)
    }
  },
  getters: {
    isAuthenticated (state) {
      return state.user !== null &&
        state.user !== undefined &&
        Firebase.auth().currentUser.emailVerified === true
    },
    exsistingStories (state) {
      return state.stories
    },
    getStory (state) {
      return state.stories.filter(story => story.title === state.selectedStory)[0]
    },
    getNewStoryId (state) {
      return state.newStoryAddedId
    },
    getObjectId (state) {
      return state.objectId
    },
    getStartTime (state) {
      return state.inspector.main.startTime
    },
    getEndTime (state) {
      return state.inspector.main.endTime
    },
    getImage (state) {
      return state.inspector.main.image
    },
    getTts (state) {
      return state.inspector.textToSpeech
    },
    getAnimations (state) {
      return state.inspector.animation
    },
    getName (state) {
      return state.inspector.main.name
    },
    getSelectedStoryId (state) {
      return state.selectedStoryId
    },
    getModel (state) {
      return state.inspector.main.model
    },
    getPropModels (state) {
      return state.propModels
    },
    getFbxModels (state) {
      return state.fbxModels
    },
    getCharacters (state) {
      return state.characters
    },
    getSounds (state) {
      return state.sounds
    },
    getMediaImages (state) {
      return state.mediaImages
    },
    getVideos (state) {
      // console.log(state.videos)
      return state.videos
    },
    getCurrentPageRoute (state) {
      return state.currentPageRoute
    }
  }
})
store.registerModule('store', assets)



// WEBPACK FOOTER //
// ./src/store/index.js